export default {
  white: '#fff',
  black: '#000',

  // social
  facebook: '#3b5998',
  instagram: '#e1306c',
  linkedin: '#4875B4',

  // theme
  primary: '#e76800',
  secondary: '#474747',
};
